// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"606":"16675a3f","1169":"16675a3f","2161":"16675a3f","3617":"37b0dae5","3665":"16675a3f","3856":"2cc25182","4971":"16675a3f","5108":"2601f373","8987":"16675a3f"}[chunkId] + ".chunk.css";
};